import { MaterialInspectionDetialByData } from '@Src/_basic/object/MaterialInspectionType';
import { Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';

interface Props {
  row: MaterialInspectionDetialByData;
}
export default function CreateTimeColumnFormatter(props: Props) {
  const { row } = props;
  return <Typography variant="inherit">{moment(row.createTime).format('YYYY/MM/DD HH:mm')}</Typography>;
}
